import { ClassName, Icon, Size } from '@busybusy/webapp-react-ui';
import { ChevronRightIcon } from 'assets/icons';
import classNames from 'classnames';
import Typography from 'components/foundation/text/Typography/Typography';
import './DashboardCardWarningBanner.scss';
import FlexContainer from '@busybusy/webapp-react-ui/dist/components/FlexContainer/FlexContainer';

export interface IDashboardCardWarningBannerProps {
  warningText: string;
  onClick?: () => void;
  className?: ClassName;
}

export default function DashboardCardWarningBanner({
  warningText,
  onClick,
  className,
}: IDashboardCardWarningBannerProps) {
  const classes = classNames('dashboard-card-warning-banner', 'full-width', { clickable: !!onClick }, className);

  return (
    <div className={classes} onClick={onClick}>
      <FlexContainer.Item flexGrow={1} className="no-text-select">
        <Typography tag="label" fontWeight="thin">
          {warningText}
        </Typography>
      </FlexContainer.Item>
      {!!onClick && <Icon svg={ChevronRightIcon} size={Size.LARGE} />}
    </div>
  );
}
